export const buildInfo: BuildInfo = __BUILD_INFO__;
